import FormTextAreaAutoSize from './FormTextAreaAutosize';

export default FormTextAreaAutoSize;
